var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.860352,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#6C84F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.860352C49.6737 0.860352 64 15.1866 64 32.8604C64 50.5341 49.6737 64.8604 32 64.8604C14.3263 64.8604 0 50.5341 0 32.8604C0 15.1866 14.3263 0.860352 32 0.860352ZM43.0386 45.9038C43.6271 44.0979 46.3847 26.1 46.7256 22.5536C46.8285 21.4795 46.489 20.7657 45.824 20.4471C45.0198 20.0604 43.8289 20.2537 42.4473 20.7518C40.5523 21.435 16.327 31.7209 14.9273 32.3163C13.6 32.8798 12.345 33.4948 12.345 34.3852C12.345 35.0113 12.7165 35.3633 13.7405 35.7292C14.8063 36.109 17.4901 36.923 19.0748 37.3598C20.601 37.7814 22.3388 37.4155 23.3127 36.8103C24.345 36.1689 36.2588 28.1967 37.1144 27.4983C37.9687 26.7998 38.6504 27.6944 37.952 28.3943C37.2536 29.0927 29.0755 37.0301 27.9972 38.1292C26.688 39.4635 27.6174 40.8464 28.4953 41.4002C29.4984 42.0318 36.7123 46.8708 37.799 47.6471C38.8856 48.4235 39.9875 48.7755 40.9962 48.7755C42.0049 48.7755 42.5363 47.4468 43.0386 45.9038Z",
    fill: "#1C202D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegramLogo.b6f5fdc04ea92d3739aca65c70df5e43.svg";
export { ForwardRef as ReactComponent };